import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './index.css';

// similar to DataList, but more boxed look
const Databoxes = props => {
  const { data, theme } = props;
  const dataCSS = cn(
    'databoxes',
    theme ? theme.map(css => `databoxes--${css}`).join(' ') : ''
  );

  const renderBox = (box, idx) => (
    <dl key={`${box.label.replace(/\s/g, '')}${idx}`}>
      <dt>{box.label}</dt>
      {box.line && (
        <dd>
          {box.line.content}
          <span className={'databoxes__unit'}>
            {box.line.output && <output>{box.line.output}</output>}
            {box.line.unit}
          </span>
        </dd>
      )}
    </dl>
  );

  return data && data.length ? (
    <article className={dataCSS}>{data.map(renderBox)}</article>
  ) : null;
};

Databoxes.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      line: PropTypes.shape({
        output: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        unit: PropTypes.string,
      }),
    })
  ),
  theme: PropTypes.array,
};

export default Databoxes;



// WEBPACK FOOTER //
// ./src/common/components/Databoxes/index.js